// src/store/features/location/locationSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserRoleStats, fetchProjectWpTaskStats, fetchTodaysMeetings } from "./dashboardApi";

export const getUserRoleStats = createAsyncThunk(
  "dashboard/getUserRoleStats",
  async (id, paramsOptions) => {
      const response = await fetchUserRoleStats();
      return response.data;
    }
);
export const getProjectWpTaskStats = createAsyncThunk(
  "dashboard/getProjectWpTaskStats",
  async () => {
      const response = await fetchProjectWpTaskStats();
      return response.data;
    }
);

export const getTodaysMeetings = createAsyncThunk(
  "dashboard/getTodaysMeetings",
  async () => {
      const response = await fetchTodaysMeetings();
      return response.data;
    }
);
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    usreRolesStats: [],
    projectWpTaskStats: [],
    todaysMeetings: [],
    loading: false,
  },
  reducers: {
    resetDashboard: (state) => {
      state.usreRolesStats = [];
      state.projectWpTaskStats = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserRoleStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserRoleStats.fulfilled, (state, action) => {
        state.usreRolesStats = action.payload;
      })
      .addCase(getProjectWpTaskStats.fulfilled, (state, action) => {
        state.projectWpTaskStats = action.payload;
      })
      .addCase(getTodaysMeetings.fulfilled, (state, action) => {
        state.todaysMeetings = action.payload;
      });
  },
});

export const { resetDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
